import { useState } from "react";
import PlayQuestion from "../../model/playQuestion";
import { setOptionChosen } from "../providers/playQuestion";

export function usePlayQuestion(): [PlayQuestion, Function] {
    const [state, setState] = useState({
        optionChosen: -1,
    });

    return [state, (option: number) => setOptionChosen(setState, option)];
}
